export default __webpack_public_path__ + "static/3-cd325b1951df39c139a4fa746cc46a62.jpg";